
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3D12W", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $1yB28 = parcelRequire("1yB28");


var $jypE9 = parcelRequire("jypE9");


var $21K7m = parcelRequire("21K7m");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $aWwYt = parcelRequire("aWwYt");


var $8aF6s = parcelRequire("8aF6s");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $cMvMc = parcelRequire("cMvMc");


var $ep3mz = parcelRequire("ep3mz");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $iBnoc = parcelRequire("iBnoc");


var $fHAwL = parcelRequire("fHAwL");


var $cZa7r = parcelRequire("cZa7r");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $1ggpj = parcelRequire("1ggpj");


var $8uM2K = parcelRequire("8uM2K");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $404f4d0022b5692a$var$commentIconContainerStyle = null;
const $404f4d0022b5692a$var$i18n = (0, $aXWIB.defineMessages)({
    viewAllCommentsLabel: {
        id: "object-sidebar-components.view.all.comments",
        defaultMessage: "View all comments"
    },
    showCommentsLabel: {
        id: "object-sidebar-components.show.comments.label",
        defaultMessage: "Show comments"
    }
});
const $404f4d0022b5692a$export$f5ef73dad1bb3f02 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(70);
    const { onClick: onClick, collapsed: collapsed, testId: testId, isStandaloneComment: t1, isDisabled: t2, isViewAllIcon: t3 } = t0;
    const isStandaloneComment = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const isViewAllIcon = t3 === undefined ? false : t3;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    let t4;
    if ($[0] !== pageMode) {
        t4 = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
        $[0] = pageMode;
        $[1] = t4;
    } else t4 = $[1];
    const eventEmitter = t4;
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [t5] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode, isEditMode: isLiveEditMode } = t5;
    const dataTestId = testId || "object-sidebar-comments-button-id";
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const t6 = pageMode === "edit" || isLiveEditMode;
    let t7;
    if ($[2] !== t6) {
        t7 = {
            shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            isEditorShortcut: t6
        };
        $[2] = t6;
        $[3] = t7;
    } else t7 = $[3];
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t7);
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE;
    let t8;
    if ($[4] !== pageMode) {
        t8 = ()=>{
            (0, $5fMeR.preloadCommentsPanel)(pageMode);
        };
        $[4] = pageMode;
        $[5] = t8;
    } else t8 = $[5];
    const handleMouseEnter = t8;
    let t9;
    if ($[6] !== activeHighlight || $[7] !== closeCommentContainer || $[8] !== editorCreateProps || $[9] !== editorViewProps || $[10] !== eventEmitter || $[11] !== expanded || $[12] !== hideObjectSidebar || $[13] !== hoverProps || $[14] !== newCommentHighlight || $[15] !== panel?.id || $[16] !== selectionOptions || $[17] !== selectionProps || $[18] !== setEditorCreateProps || $[19] !== setEditorViewProps || $[20] !== setHoverProps || $[21] !== setSelectionOptions || $[22] !== setSelectionProps || $[23] !== setShowCreateComponent || $[24] !== setViewProps || $[25] !== showCommentsPanel || $[26] !== showCreateComponent || $[27] !== viewProps) {
        t9 = ()=>{
            if (viewProps) {
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                setViewProps(null);
            }
            if (showCreateComponent && selectionOptions) {
                setShowCreateComponent(false);
                setSelectionOptions(undefined);
            }
            if (editorViewProps) {
                eventEmitter.emit("setselectedannotation", "");
                setEditorViewProps(null);
            }
            if (selectionProps) {
                selectionProps.onClose();
                setSelectionProps(null);
            }
            if (hoverProps) {
                hoverProps.onClose();
                setHoverProps(null);
            }
            if (editorCreateProps) {
                editorCreateProps?.onClose && editorCreateProps.onClose();
                setEditorCreateProps(null);
            }
            if (newCommentHighlight || activeHighlight) window.dispatchEvent(new Event("closeLegacyInlineCommentSidebar"));
            if (expanded && !(0, $9wGTI.fg)("confluence_comment_panel_close_footer")) closeCommentContainer();
            if (panel?.id === "commentsPanel") hideObjectSidebar();
            else showCommentsPanel();
        };
        $[6] = activeHighlight;
        $[7] = closeCommentContainer;
        $[8] = editorCreateProps;
        $[9] = editorViewProps;
        $[10] = eventEmitter;
        $[11] = expanded;
        $[12] = hideObjectSidebar;
        $[13] = hoverProps;
        $[14] = newCommentHighlight;
        $[15] = panel?.id;
        $[16] = selectionOptions;
        $[17] = selectionProps;
        $[18] = setEditorCreateProps;
        $[19] = setEditorViewProps;
        $[20] = setHoverProps;
        $[21] = setSelectionOptions;
        $[22] = setSelectionProps;
        $[23] = setShowCreateComponent;
        $[24] = setViewProps;
        $[25] = showCommentsPanel;
        $[26] = showCreateComponent;
        $[27] = viewProps;
        $[28] = t9;
    } else t9 = $[28];
    const handleCommentClick = t9;
    let t10;
    if ($[29] !== contentTypeFromState || $[30] !== createAnalyticsEvent || $[31] !== handleCommentClick || $[32] !== hasContentChanged || $[33] !== onClick || $[34] !== pageMode || $[35] !== resetContentChanged || $[36] !== resetInitialDataLoadedMap || $[37] !== showModal) {
        t10 = (t11)=>{
            const { triggeredByKeyboardShortcut: t12, isViewAllIcon: t13 } = t11 === undefined ? {} : t11;
            const triggeredByKeyboardShortcut = t12 === undefined ? false : t12;
            const isViewAllIcon_0 = t13 === undefined ? false : t13;
            return ()=>{
                if (isViewAllIcon_0) {
                    onClick?.();
                    return;
                }
                if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: ()=>{
                        resetContentChanged();
                        handleCommentClick();
                        if ((0, $9wGTI.fg)("confluence_comments_reset_data_on_comment_discard")) resetInitialDataLoadedMap();
                    }
                });
                else handleCommentClick();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "commentsPanel",
                        source: "contentWrapper",
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            contentType: contentTypeFromState,
                            pageMode: pageMode
                        }
                    }
                }).fire();
            };
        };
        $[29] = contentTypeFromState;
        $[30] = createAnalyticsEvent;
        $[31] = handleCommentClick;
        $[32] = hasContentChanged;
        $[33] = onClick;
        $[34] = pageMode;
        $[35] = resetContentChanged;
        $[36] = resetInitialDataLoadedMap;
        $[37] = showModal;
        $[38] = t10;
    } else t10 = $[38];
    const checkUnsavedOnClickCommentsButton = t10;
    let t11;
    if ($[39] !== checkUnsavedOnClickCommentsButton || $[40] !== isLiveViewMode || $[41] !== pageMode) {
        t11 = (pageMode === "view" || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[39] = checkUnsavedOnClickCommentsButton;
        $[40] = isLiveViewMode;
        $[41] = pageMode;
        $[42] = t11;
    } else t11 = $[42];
    let t12;
    if ($[43] !== checkUnsavedOnClickCommentsButton || $[44] !== isLiveEditMode || $[45] !== pageMode) {
        t12 = (pageMode === "edit" || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[43] = checkUnsavedOnClickCommentsButton;
        $[44] = isLiveEditMode;
        $[45] = pageMode;
        $[46] = t12;
    } else t12 = $[46];
    let t13;
    if ($[47] !== t11 || $[48] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t11, t12);
        $[47] = t11;
        $[48] = t12;
        $[49] = t13;
    } else t13 = $[49];
    const shortcutListeners = t13;
    if (collapsed) return shortcutListeners;
    let t14;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $gMc0m.default)([
            "_kqswh2mm"
        ]);
        $[50] = t14;
    } else t14 = $[50];
    let t15;
    if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $404f4d0022b5692a$var$i18n.showCommentsLabel);
        $[51] = t15;
    } else t15 = $[51];
    const t16 = isShortcutTextShown ? commentShortcutStrings : undefined;
    let t17;
    if ($[52] !== allowComments || $[53] !== checkUnsavedOnClickCommentsButton || $[54] !== formatMessage || $[55] !== handleMouseEnter || $[56] !== isDisabled || $[57] !== isRovoButtonEnabled || $[58] !== isStandaloneComment || $[59] !== isViewAllIcon || $[60] !== unreadCommentIDSet?.size) {
        t17 = allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            onClick: checkUnsavedOnClickCommentsButton({
                isViewAllIcon: isViewAllIcon
            }),
            onMouseEnter: handleMouseEnter,
            appearance: "subtle",
            spacing: isStandaloneComment ? "compact" : undefined,
            shape: isRovoButtonEnabled ? "default" : "circle",
            icon: isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_cohiti_panel_icon_update", "isEnabled", true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
            label: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel),
            testId: "sidebar-comments-button",
            interactionName: "view-comments-menu-action",
            isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
        }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null));
        $[52] = allowComments;
        $[53] = checkUnsavedOnClickCommentsButton;
        $[54] = formatMessage;
        $[55] = handleMouseEnter;
        $[56] = isDisabled;
        $[57] = isRovoButtonEnabled;
        $[58] = isStandaloneComment;
        $[59] = isViewAllIcon;
        $[60] = unreadCommentIDSet?.size;
        $[61] = t17;
    } else t17 = $[61];
    const t18 = !isStandaloneComment && shortcutListeners;
    let t19;
    if ($[62] !== t16 || $[63] !== t17 || $[64] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: t15,
            shortcut: t16,
            delay: 0,
            hideTooltipOnClick: true
        }, t17, t18);
        $[62] = t16;
        $[63] = t17;
        $[64] = t18;
        $[65] = t19;
    } else t19 = $[65];
    let t20;
    if ($[66] !== dataTestId || $[67] !== t14 || $[68] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": dataTestId,
            "data-vc": "object-sidebar-comments-button",
            className: t14
        }, t19);
        $[66] = dataTestId;
        $[67] = t14;
        $[68] = t19;
        $[69] = t20;
    } else t20 = $[69];
    return t20;
} : ({ onClick: onClick, collapsed: collapsed, testId: testId, isStandaloneComment: isStandaloneComment = false, isDisabled: isDisabled = false, isViewAllIcon: isViewAllIcon = false })=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [{ isViewMode: isLiveViewMode, isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const dataTestId = testId || 'object-sidebar-comments-button-id';
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        isEditorShortcut: pageMode === 'edit' || isLiveEditMode
    });
    // keyboard events do not bubble up to confluence when focus is in the db iframe.
    // Since the keyboard shortcut does not work, we must hide the shortcut text.
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE; // Preload components on hover to improve FMP performance
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        (0, $5fMeR.preloadCommentsPanel)(pageMode);
    }, [
        pageMode
    ]);
    const handleCommentClick = (0, $42omo.useCallback)(()=>{
        // FABRIC PAGES
        // Close the view component if it's open
        if (viewProps) {
            // Inform the Renderer to de-select the annotation
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS); // Remove the display of the comment
            setViewProps(null);
        }
        if (showCreateComponent && selectionOptions) {
            // Inform CreateComment to reset the state
            setShowCreateComponent(false);
            setSelectionOptions(undefined);
        }
        if (editorViewProps) {
            // Inform the editor to de-select the annotation
            eventEmitter.emit('setselectedannotation', ''); // Remove the display of the comment
            setEditorViewProps(null);
        }
        if (selectionProps) {
            selectionProps.onClose();
            setSelectionProps(null);
        }
        if (hoverProps) {
            hoverProps.onClose();
            setHoverProps(null);
        }
        if (editorCreateProps) {
            editorCreateProps?.onClose && editorCreateProps.onClose();
            setEditorCreateProps(null);
        } // LEGACY PAGES
        if (newCommentHighlight || activeHighlight) // Close the legacy inline comment panel
        window.dispatchEvent(new Event('closeLegacyInlineCommentSidebar'));
         // Should unmount the expanded comment editor
        // standalone reply, object footer comment
        if (expanded && !(0, $9wGTI.fg)('confluence_comment_panel_close_footer')) closeCommentContainer();
        if (panel?.id === 'commentsPanel') hideObjectSidebar();
        else showCommentsPanel();
    }, [
        eventEmitter,
        viewProps,
        editorViewProps,
        selectionProps,
        hoverProps,
        newCommentHighlight,
        activeHighlight,
        setViewProps,
        setEditorViewProps,
        setSelectionProps,
        setHoverProps,
        showCommentsPanel,
        hideObjectSidebar,
        panel,
        editorCreateProps,
        closeCommentContainer,
        expanded,
        setEditorCreateProps,
        showCreateComponent,
        selectionOptions,
        setShowCreateComponent,
        setSelectionOptions
    ]);
    const checkUnsavedOnClickCommentsButton = (0, $42omo.useCallback)(({ triggeredByKeyboardShortcut: triggeredByKeyboardShortcut = false, isViewAllIcon: isViewAllIcon_0 = false } = {})=>()=>{
            // Early return for ViewAll icon - no action needed
            if (isViewAllIcon_0) {
                onClick?.();
                return;
            }
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    handleCommentClick();
                    if ((0, $9wGTI.fg)('confluence_comments_reset_data_on_comment_discard')) resetInitialDataLoadedMap();
                }
            });
            else handleCommentClick();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'commentsPanel',
                    source: 'contentWrapper',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        contentType: contentTypeFromState,
                        pageMode: pageMode
                    }
                }
            }).fire();
        }, [
        onClick,
        hasContentChanged,
        handleCommentClick,
        resetContentChanged,
        resetInitialDataLoadedMap,
        showModal,
        createAnalyticsEvent,
        contentTypeFromState,
        pageMode
    ]);
    const shortcutListeners = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (pageMode === 'view' || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }), (pageMode === 'edit' || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }));
    if (collapsed) return shortcutListeners;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        "data-vc": "object-sidebar-comments-button",
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $404f4d0022b5692a$var$i18n.showCommentsLabel),
        shortcut: isShortcutTextShown ? commentShortcutStrings : undefined,
        delay: 0,
        hideTooltipOnClick: true
    }, allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: checkUnsavedOnClickCommentsButton({
            isViewAllIcon: isViewAllIcon
        }),
        onMouseEnter: handleMouseEnter,
        appearance: "subtle",
        spacing: isStandaloneComment ? 'compact' : undefined,
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_panel_icon_update', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel),
        testId: "sidebar-comments-button",
        interactionName: "view-comments-menu-action",
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
    }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null)), !isStandaloneComment && shortcutListeners));
};
module.exports["CommentPanelButton"] = $404f4d0022b5692a$export$f5ef73dad1bb3f02;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("8FCWK"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("8FCWK", function(module, exports) {

let $65005d03f1075b43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $65005d03f1075b43$var$load("hhss7"),
    $65005d03f1075b43$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("fNzRA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $en1dX = parcelRequire("en1dX");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

var $7b4a2f6cc35c72e1$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    // The footer comments section
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    // The sticky draft that persists outside of the footer
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $7b4a2f6cc35c72e1$export$8a175172a11240d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    expandCommentContainer: ()=>{},
    closeCommentContainer: ()=>{},
    setWrapperWidth: ()=>{},
    setIsObjectCommentWrapperVisible: ()=>{},
    setFooterEditorEntry: ()=>{}
});
$7b4a2f6cc35c72e1$export$8a175172a11240d4.displayName = 'ObjectCommentDispatchContext';
const $7b4a2f6cc35c72e1$export$358734f355c08965 = /*#__PURE__*/ (0, $42omo.createContext)({
    expanded: false,
    footerEditorEntry: undefined,
    width: undefined,
    isObjectCommentWrapperVisible: false
});
$7b4a2f6cc35c72e1$export$358734f355c08965.displayName = 'ObjectCommentContext';
const $7b4a2f6cc35c72e1$export$d248a0e4aca56201 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { children: children } = t0;
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== expanded || $[1] !== footerEditorEntry || $[2] !== isObjectCommentWrapperVisible || $[3] !== width) {
        t1 = {
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        };
        $[0] = expanded;
        $[1] = footerEditorEntry;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    const providerValue = t1;
    let t2;
    if ($[5] !== edition) {
        t2 = (props)=>{
            const { entryPoint: entryPoint } = props ?? {};
            if (entryPoint && (0, $9wGTI.fg)("confluence_fe_add_page_comment_exp_coverage")) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    editor: "FABRIC",
                    isSingleExperience: true,
                    edition: edition,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    entryPoint: entryPoint
                }
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            setExpanded(true);
        };
        $[5] = edition;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setFooterEditorEntry(undefined);
            setExpanded(false);
        };
        t4 = (width_0)=>{
            setWidth(width_0 ? `${width_0}px` : "100%");
        };
        t5 = (visible)=>{
            setIsObjectCommentWrapperVisible(visible);
        };
        t6 = (footerEditorEntry_0)=>{
            setFooterEditorEntry(footerEditorEntry_0);
        };
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else {
        t3 = $[7];
        t4 = $[8];
        t5 = $[9];
        t6 = $[10];
    }
    let t7;
    if ($[11] !== t2) {
        t7 = {
            expandCommentContainer: t2,
            closeCommentContainer: t3,
            setWrapperWidth: t4,
            setIsObjectCommentWrapperVisible: t5,
            setFooterEditorEntry: t6
        };
        $[11] = t2;
        $[12] = t7;
    } else t7 = $[12];
    const dispatchProviderValue = t7;
    let t8;
    if ($[13] !== children || $[14] !== dispatchProviderValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
            value: dispatchProviderValue
        }, children);
        $[13] = children;
        $[14] = dispatchProviderValue;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== providerValue || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
            value: providerValue
        }, t8);
        $[16] = providerValue;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
} : ({ children: children })=>{
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const providerValue = (0, $42omo.useMemo)(()=>({
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        }), [
        expanded,
        footerEditorEntry,
        width,
        isObjectCommentWrapperVisible
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            expandCommentContainer: (props)=>{
                const { entryPoint: entryPoint } = props ?? {};
                if (entryPoint && (0, $9wGTI.fg)('confluence_fe_add_page_comment_exp_coverage')) (0, $8Ss4E.startEditorExperiences)({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    attributes: {
                        editor: 'FABRIC',
                        isSingleExperience: true,
                        edition: edition,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        entryPoint: entryPoint
                    }
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                setExpanded(true);
            },
            closeCommentContainer: ()=>{
                setFooterEditorEntry(undefined);
                setExpanded(false);
            },
            setWrapperWidth: (width_0)=>{
                setWidth(width_0 ? `${width_0}px` : '100%');
            },
            setIsObjectCommentWrapperVisible: (visible)=>{
                setIsObjectCommentWrapperVisible(visible);
            },
            setFooterEditorEntry: (footerEditorEntry_0)=>{
                setFooterEditorEntry(footerEditorEntry_0);
            }
        }), [
        setExpanded,
        setFooterEditorEntry,
        setWidth,
        setIsObjectCommentWrapperVisible,
        edition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $7b4a2f6cc35c72e1$export$da430766ddf17a6b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
};
const $7b4a2f6cc35c72e1$export$8ba3235fe153fa01 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
};
module.exports["AddFooterCommentMode"] = $7b4a2f6cc35c72e1$export$94f8d08c2312472b;
module.exports["ObjectCommentProvider"] = $7b4a2f6cc35c72e1$export$d248a0e4aca56201;
module.exports["useObjectCommentContext"] = $7b4a2f6cc35c72e1$export$da430766ddf17a6b;
module.exports["useObjectCommentDispatchContext"] = $7b4a2f6cc35c72e1$export$8ba3235fe153fa01;

});

parcelRegister("en1dX", function(module, exports) {
var $88e03e673e36ecc4$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["COMMENTS_PANEL"] = "commentsPanel";
    AnalyticsSource["STANDALONE"] = "standalone";
    AnalyticsSource["PAGE_FOOTER"] = "pageFooter";
    return AnalyticsSource;
}({});
var $88e03e673e36ecc4$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["REOPEN_COMMENT"] = "reopenComment";
    return ActionName;
}({});
var $88e03e673e36ecc4$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    CommentType["PAGE"] = "page";
    return CommentType;
}({});
module.exports["AnalyticsSource"] = $88e03e673e36ecc4$export$6890652a1aff7d1c;
module.exports["ActionName"] = $88e03e673e36ecc4$export$9c95d6e1614bad84;
module.exports["CommentType"] = $88e03e673e36ecc4$export$ffa1150e6a48f9cd;

});

parcelRegister("bSvtO", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $1P1Tu.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $9zUhf.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $9zUhf.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $9zUhf.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("9JyKa"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("ccgLb"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("6PB7O"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("vKOg1"))).CommentsPanelWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelFooterWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uSRQM",
    name: "CommentsPanelFooterWrapper",
    loader: async ()=>(await (parcelRequire("hPhAw"))).CommentsPanelFooterWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelFilterMenuWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "GWpr1",
    name: "CommentsPanelFilterMenuWrapper",
    loader: async ()=>(await (parcelRequire("jOWbX"))).CommentsPanelFilterMenuWrapper
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    },
    discussionsPanelHeaderLabel: {
        id: "comments-panel.panel.header.discussions.label",
        defaultMessage: "Discussions"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const isSlidesView = (0, $gEtAQ.isSlides)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelCloseCallback = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const onPanelClose = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? onPanelCloseCallback : onPanelCloseFunction;
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        // Drag-to-resize on page surfaces only (same exclusions as the panel
        // itself). `expValEquals` is the LAST clause per
        // `confluence-feature-gating/no-preconditioning` so exposure is only
        // recorded for users who actually meet the surface preconditions.
        const isResizableSurface = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView && (0, $6mKj3.expValEquals)('confluence_fe_comments_panel_resize', 'isEnabled', true);
        const showFooter = canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        // When the gate is on, use CommentsPanelFooterWrapper which reactively
        // switches between SuggestionsFooter and CommentsPanelFooter based on
        // the current tab — without needing to re-open the sidebar.
        // When the gate is off, fall back to the original CommentsPanelFooter.
        const FooterComponent = (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? $3b7f940e5fdc8097$var$CommentsPanelFooterWrapper : showFooter ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? $3b7f940e5fdc8097$export$a7357cdd1f0b0168.discussionsPanelHeaderLabel : $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? $3b7f940e5fdc8097$var$CommentsPanelFilterMenuWrapper : $3b7f940e5fdc8097$var$CommentsPanelFilterMenu
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView
                }),
            FooterComponent: FooterComponent,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            },
            isResizable: isResizableSurface
        }, 'push');
    };
    const showCommentsPanelHandler = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        isSlidesView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    const showCommentsPanel = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? showCommentsPanelHandler : showCommentsPanelFunction;
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
var $4440a0699c7a4c4d$export$6a393d893fab1730 = /*#__PURE__*/ function(SidebarTabValues) {
    SidebarTabValues["COMMENTS"] = "COMMENTS";
    SidebarTabValues["SUGGESTIONS"] = "SUGGESTIONS";
    return SidebarTabValues;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false,
            ["MENTIONS_ME"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null,
        currentSidebarTab: "COMMENTS"
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType)=>({ setState: setState })=>{
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        },
    setCurrentSidebarTab: (tab)=>({ setState: setState })=>{
            setState({
                currentSidebarTab: tab
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["SidebarTabValues"] = $4440a0699c7a4c4d$export$6a393d893fab1730;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("dANtQ", function(module, exports) {

var $i1slQ = parcelRequire("i1slQ");


var $9wEpK = parcelRequire("9wEpK");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $i1slQ.default);
const $be6154107952d370$var$noOpRefetch = ()=>Promise.resolve();
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const baseOptions = {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    };
    const queryResult = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network',
        __callerPackage__: "@confluence/comments-hooks"
    });
    const { data: data, loading: loading, error: error } = queryResult;
    const networkStatus = 'networkStatus' in queryResult && queryResult.networkStatus !== undefined ? queryResult.networkStatus : (0, $9wEpK.NetworkStatus).ready;
    const refetch = 'refetch' in queryResult && typeof queryResult.refetch === 'function' ? queryResult.refetch : $be6154107952d370$var$noOpRefetch;
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("i1slQ", function(module, exports) {
/**
 * @generated SignedSource<<9576c4641d6e53de65b0b62ec71933b2>>
 * @relayHash 5b33d38d543554afec98c6d129862ca0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9
const $fc06507f37418bb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5b33d38d543554afec98c6d129862ca0",
            "id": "c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9",
            "metadata": {},
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\",\"current\"]){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$fc06507f37418bb6$var$node.hash = "aad09466db1f47073b1a0249e54dc3a4";
var $fc06507f37418bb6$export$2e2bcd8739ae039 = $fc06507f37418bb6$var$node;
module.exports["default"] = $fc06507f37418bb6$export$2e2bcd8739ae039;

});

parcelRegister("9JyKa", function(module, exports) {

let $7163445d8a73b58f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7163445d8a73b58f$var$load("8QOYK"),
    $7163445d8a73b58f$var$load("f1meW"),
    $7163445d8a73b58f$var$load("bxJCm"),
    $7163445d8a73b58f$var$load("3Bbwl"),
    $7163445d8a73b58f$var$load("7EorR"),
    $7163445d8a73b58f$var$load("9AXkC"),
    $7163445d8a73b58f$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("ccgLb", function(module, exports) {

let $8e139b328cda2fda$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8e139b328cda2fda$var$load("kHOMt"),
    $8e139b328cda2fda$var$load("9AXkC"),
    $8e139b328cda2fda$var$load("8QOYK"),
    $8e139b328cda2fda$var$load("f1meW"),
    $8e139b328cda2fda$var$load("6wr18"),
    $8e139b328cda2fda$var$load("ffEVr"),
    $8e139b328cda2fda$var$load("gYeBT"),
    $8e139b328cda2fda$var$load("8LtYa"),
    $8e139b328cda2fda$var$load("g9CVe"),
    $8e139b328cda2fda$var$load("4m4Yp"),
    $8e139b328cda2fda$var$load("70IPm"),
    $8e139b328cda2fda$var$load("fiBiE"),
    $8e139b328cda2fda$var$load("lBssV"),
    $8e139b328cda2fda$var$load("bxJCm"),
    $8e139b328cda2fda$var$load("h3ABO"),
    $8e139b328cda2fda$var$load("kC80R"),
    $8e139b328cda2fda$var$load("7EorR"),
    $8e139b328cda2fda$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("6PB7O", function(module, exports) {

let $4f944dbe79d36182$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4f944dbe79d36182$var$load("6wr18"),
    $4f944dbe79d36182$var$load("ffEVr"),
    $4f944dbe79d36182$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("vKOg1", function(module, exports) {

let $05f734c7088bbdbd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $05f734c7088bbdbd$var$load("h3ABO"),
    $05f734c7088bbdbd$var$load("5NQgH"),
    $05f734c7088bbdbd$var$load("6wr18"),
    $05f734c7088bbdbd$var$load("2PePB"),
    $05f734c7088bbdbd$var$load("lg1HU"),
    $05f734c7088bbdbd$var$load("1GCFv"),
    $05f734c7088bbdbd$var$load("6h4WR"),
    $05f734c7088bbdbd$var$load("lNrIG"),
    $05f734c7088bbdbd$var$load("5p45W"),
    $05f734c7088bbdbd$var$load("1H5IN"),
    $05f734c7088bbdbd$var$load("a9w2G"),
    $05f734c7088bbdbd$var$load("gYeBT"),
    $05f734c7088bbdbd$var$load("iGCP8"),
    $05f734c7088bbdbd$var$load("7GBD7"),
    $05f734c7088bbdbd$var$load("cmqxT"),
    $05f734c7088bbdbd$var$load("6cnH1"),
    $05f734c7088bbdbd$var$load("lkOIY"),
    $05f734c7088bbdbd$var$load("dI1Cd"),
    $05f734c7088bbdbd$var$load("jbxHq"),
    $05f734c7088bbdbd$var$load("l0dTs"),
    $05f734c7088bbdbd$var$load("8YSo7"),
    $05f734c7088bbdbd$var$load("7do1E"),
    $05f734c7088bbdbd$var$load("77dkW"),
    $05f734c7088bbdbd$var$load("9ijrN"),
    $05f734c7088bbdbd$var$load("Wowvf"),
    $05f734c7088bbdbd$var$load("4m4Yp"),
    $05f734c7088bbdbd$var$load("cyGuT"),
    $05f734c7088bbdbd$var$load("ffEVr"),
    $05f734c7088bbdbd$var$load("9AXkC"),
    $05f734c7088bbdbd$var$load("28arV"),
    $05f734c7088bbdbd$var$load("hhss7"),
    $05f734c7088bbdbd$var$load("34Msw"),
    $05f734c7088bbdbd$var$load("filLQ"),
    $05f734c7088bbdbd$var$load("iTJMK"),
    $05f734c7088bbdbd$var$load("2A8WX"),
    $05f734c7088bbdbd$var$load("fd6hr"),
    $05f734c7088bbdbd$var$load("70IPm"),
    $05f734c7088bbdbd$var$load("fiBiE"),
    $05f734c7088bbdbd$var$load("lBssV"),
    $05f734c7088bbdbd$var$load("cXoAq"),
    $05f734c7088bbdbd$var$load("dP7ao"),
    $05f734c7088bbdbd$var$load("hogcU"),
    $05f734c7088bbdbd$var$load("31vk5"),
    $05f734c7088bbdbd$var$load("8QOYK"),
    $05f734c7088bbdbd$var$load("f1meW"),
    $05f734c7088bbdbd$var$load("32WMp"),
    $05f734c7088bbdbd$var$load("hl7Lf"),
    $05f734c7088bbdbd$var$load("gwky3"),
    $05f734c7088bbdbd$var$load("cWN1a"),
    $05f734c7088bbdbd$var$load("bxJCm"),
    $05f734c7088bbdbd$var$load("3BUaw"),
    $05f734c7088bbdbd$var$load("8ublV"),
    $05f734c7088bbdbd$var$load("gBYaP"),
    $05f734c7088bbdbd$var$load("abjZY"),
    $05f734c7088bbdbd$var$load("6Etmm"),
    $05f734c7088bbdbd$var$load("7EorR"),
    $05f734c7088bbdbd$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("hPhAw", function(module, exports) {

let $cfa4d7b02392cab6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cfa4d7b02392cab6$var$load("kHOMt"),
    $cfa4d7b02392cab6$var$load("9AXkC"),
    $cfa4d7b02392cab6$var$load("8QOYK"),
    $cfa4d7b02392cab6$var$load("f1meW"),
    $cfa4d7b02392cab6$var$load("6wr18"),
    $cfa4d7b02392cab6$var$load("ffEVr"),
    $cfa4d7b02392cab6$var$load("gYeBT"),
    $cfa4d7b02392cab6$var$load("8LtYa"),
    $cfa4d7b02392cab6$var$load("g9CVe"),
    $cfa4d7b02392cab6$var$load("4m4Yp"),
    $cfa4d7b02392cab6$var$load("70IPm"),
    $cfa4d7b02392cab6$var$load("fiBiE"),
    $cfa4d7b02392cab6$var$load("lBssV"),
    $cfa4d7b02392cab6$var$load("bxJCm"),
    $cfa4d7b02392cab6$var$load("6q8Rl"),
    $cfa4d7b02392cab6$var$load("h3ABO"),
    $cfa4d7b02392cab6$var$load("kC80R"),
    $cfa4d7b02392cab6$var$load("7EorR"),
    $cfa4d7b02392cab6$var$load("ioZhb")
]).then(()=>parcelRequire('eBrKE'));

});

parcelRegister("jOWbX", function(module, exports) {

let $e6dfd3828cd5bfbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e6dfd3828cd5bfbe$var$load("8QOYK"),
    $e6dfd3828cd5bfbe$var$load("f1meW"),
    $e6dfd3828cd5bfbe$var$load("bxJCm"),
    $e6dfd3828cd5bfbe$var$load("3Bbwl"),
    $e6dfd3828cd5bfbe$var$load("7EorR"),
    $e6dfd3828cd5bfbe$var$load("9AXkC"),
    $e6dfd3828cd5bfbe$var$load("bZz7X"),
    $e6dfd3828cd5bfbe$var$load("7f4Qm")
]).then(()=>parcelRequire('5f3kS'));

});

parcelRegister("iBnoc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0360a9befc1d1e18$export$d101cbe06551091d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1wNs0",
    name: "UnreadIndicator",
    loader: async ()=>(await (parcelRequire("9bA4s"))).UnreadIndicator
});
module.exports["UnreadIndicator"] = $0360a9befc1d1e18$export$d101cbe06551091d;

});

parcelRegister("9bA4s", function(module, exports) {

let $6b011f0f99d5e581$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b011f0f99d5e581$var$load("i8hiG").then(()=>parcelRequire('yTrVP'));

});

parcelRegister("fHAwL", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $7fff4328005dca96$var$initialState = {
    // isUpdatingUnreadComments tracks when we're updating the unread comments set
    // (e.g., during initial render or when manually updating the set).
    isUpdatingUnreadComments: true,
    // isUnreadQueryLoading tracks when we're actively fetching comments from the server.
    isUnreadQueryLoading: false,
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    setIsUpdatingUnreadComments: (isUpdatingUnreadComments)=>({ setState: setState })=>{
            setState({
                isUpdatingUnreadComments: isUpdatingUnreadComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $9zUhf.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $9zUhf.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $9zUhf.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});


//# sourceMappingURL=CommentPanelButton.a979860a.js.map
